import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class EntityModel extends BaseModel {
  static urlPath = "entities";

  @attr("number") pk;
  @attr("string") name;
  @attr("string") entityTypeLabel;
  @attr("number") entityType;
  @attr("json") parent;
  @belongsTo("address") address;
  @attr("string") phone;
  @attr("string") email;
  @attr("string") website;
  @attr("boolean") inNetwork;
  @attr("number") locationCount;
  @attr("string") einNumber;
  @attr("string") title;
  @attr("array") permissionSets;
  @attr("array") groupSetNames;
}
